/**
 * @module app.um
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ICodes } from 'app/ext/cwqi/cwqi-manager';

@autoinject()
export class DocumentMedicalDisplay extends ComponentBase {

    ////****************** Fields and Properties **************************************////
    @bindable.objectNull
    protected documentService: ICodes | null = null;


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) ******************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***********************************************////


    ////****************** Functions ***********************************************////


}
